import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useMessages({ chatId }) {
  const [messages, setMessages] = useState(null);

  const prepareMessage = (message) => {
    const result = [];

    const position = message.attributes.from === 'member' ? 'right' : 'left';
    if (message.attributes.body !== '') {
      result.push({
        id: `${message.id}-text`,
        realId: message.id,
        isRead: message.attributes.read,
        created: message.attributes.created_at,
        position,
        type: message.attributes.is_system ? 'system' : 'text',
        text: message.attributes.message.replace('btn-green', 'btn-primary'),
      });
    }

    if (message.attributes.file) {
      let mediaType = 'file';
      if (message.attributes.is_image) {
        mediaType = 'photo';
      }
      if (message.attributes.is_video) {
        mediaType = 'video';
      }

      result.push({
        id: `${message.id}-media`,
        realId: message.id,
        isRead: message.attributes.read,
        created: message.attributes.created_at,
        position,
        type: mediaType,
        text: message.attributes.file.name,
        video_content: message.attributes.video_content,
        data: {
          uri: message.attributes.file.url,
          size: message.attributes.file.human_size,
          name: message.attributes.file.name,
          status: {
            click: true,
          },
        },
      });
    }

    return result;
  };

  const addMessage = (rawMessage) => {
    setMessages((prev) => [
      ...prev,
      ...prepareMessage(rawMessage),
    ]);
  };

  useEffect(() => {
    setMessages(null);
    axios
      .get(routes.api.session_rooms.messages.index(chatId), {
        params: {
          with_system: true,
        },
      })
      .then((response) => {
        const processedMessages = response.data.data.reverse().flatMap((message) => prepareMessage(message));

        setMessages(processedMessages);
      });
  }, [chatId]);

  return { messages, addMessage };
}
